<template>
  <button class="btn" type="button" :disabled="disabled" v-bind="$attrs" v-on="$listeners">
    <span
      class="spinner-border spinner-border-sm mr-2"
      role="status"
      aria-hidden="true"
      v-if="loading"
    ></span>
    <slot name="body">
      <slot name="body-icon"></slot>
      <slot name="body-text">
        <span class="p-2" :class="{ uppercase: uppercase }">{{ title }}</span>
      </slot>
    </slot>
  </button>
</template>

<script>
export default {
  name: "VueButton",
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Button",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    disabled() {
      return this.disable || this.loading;
    },
  },
};
</script>

<style lang="scss" scoped>
.uppercase {
  text-transform: uppercase;
}

.btn {
  border-radius: 11px;
  font-weight: 700;
  letter-spacing: -0.01em;
  box-shadow: none;
  transition: transform 0.15s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

.btn-primary {
  background-color: var(--portal-primary);
  border-color: var(--portal-primary);
  box-shadow: 0 6px 14px rgba(79, 70, 229, 0.22);

  &:hover,
  &:focus {
    background-color: var(--portal-primary);
    border-color: var(--portal-primary);
    opacity: 0.95;
    transform: translateY(-1px);
  }
}

.btn:disabled {
  opacity: 0.65;
  transform: none;
  box-shadow: none;
}
</style>
